/**
* 分页组件
*/ 
<template>
  <el-pagination class="page-box"  :pager-count="5" @size-change="handleSizeChange" @current-change="handleCurrentChange" 
  background :current-page.sync="childMsg.pageNum" :page-sizes="[10,20,40,60,100]" :page-size.sync="childMsg.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="childMsg.total">
  </el-pagination>
</template>
<script>
export default {
  name: "Pagination",
  props: ["childMsg"],
  data() {
    return {
      pageparm: {
        pageNum: this.childMsg.pageNum,
        pageSize: this.childMsg.pageSize
      }
    };
  },
  created() {},
  methods: {
    handleSizeChange(val) {
      /**
       * 子传父
       * 参数1 父元素方法
       * 参数2 数据
       */
      this.pageparm.pageSize = val;
      this.$emit("callFather", this.pageparm);
    },
    handleCurrentChange(val) {
      /**
       * 子传父
       * 参数1 父元素方法
       * 参数2 数据
       */
      this.pageparm.pageNum = val;
      this.$emit("callFather", this.pageparm);
    }
  }
};
</script>

<style>
.page-box {
  margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue